import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { SelectContent, SelectItem, SelectValue } from '@/components/ui/select';
import { SelectTrigger } from '@/components/ui/select';

import { userStatus } from '@/api/employee';
import { EmployeeDTO, useChangeStatusEmployee } from '@/hooks/useEmployee';
import { Label } from '@/components/ui/label';
import { Select } from '@/components/ui/select';
import { z } from 'zod';
import { IEmployee } from '@/api/employee';

const changeEmployeeSchema = z.object({
  id: z.string().min(1, { message: 'Vui lòng chọn nhân viên phụ trách mới' }),
});

function CreateUpdate({
  itemChangeEmployee,
  open,
  setOpen,
  employeesData,
  setItemChangeEmployee,
}: {
  itemChangeEmployee?: EmployeeDTO | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  employeesData: IEmployee[];
  setItemChangeEmployee: (item: EmployeeDTO | null) => void;
}) {
  const { mutate: changeStatusEmployee } = useChangeStatusEmployee();
  const form = useForm<z.infer<typeof changeEmployeeSchema>>({
    resolver: zodResolver(changeEmployeeSchema),
    defaultValues: {
      id: itemChangeEmployee?.id || '',
    },
    mode: 'onChange',
  });

  async function onSubmit(values: z.infer<typeof changeEmployeeSchema>) {
    changeStatusEmployee({
      id: itemChangeEmployee?.id || '',
      status: userStatus.INACTIVE,
      idEmployeeNew: Number(values.id),
    });
    setOpen(false);
    setItemChangeEmployee(null);
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        form.reset();
        setOpen(value);
      }}
    >
      <DialogContent
        className="min-w-[500px] max-h-[95vh] overflow-y-auto luxury-dialog"
        aria-describedby="dialog-description"
      >
        <DialogDescription className="sr-only">
          Thay đổi nhân viên phụ trách mới
        </DialogDescription>
        <DialogHeader className="luxury-header">
          <DialogTitle className="luxury-title">
            Thay đổi nhân viên phụ trách mới
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-8"
            autoComplete="off"
          >
            <div className="luxury-card">
              <h3 className="luxury-subtitle mb-2">
                Thay đổi nhân viên phụ trách mới
              </h3>
              <div className="text-sm text-[red] mb-4">
                Bạn sẽ chuyển tất cả khách hàng hiện tại của nhân viên{' '}
                <span className="font-bold text-base">
                  {itemChangeEmployee?.username}
                </span>{' '}
                sang nhân viên phụ trách mới.
              </div>
              <FormField
                control={form.control}
                name="id"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <Label required className="luxury-label">
                      Nhân viên phụ trách
                    </Label>
                    <FormControl>
                      <Select
                        value={field.value?.toString() || ''}
                        onValueChange={(value) => field.onChange(value)}
                      >
                        <SelectTrigger className="w-full luxury-input">
                          <SelectValue placeholder="Chọn nhân viên" />
                        </SelectTrigger>
                        <SelectContent className="border-luxury-200">
                          {employeesData
                            ?.filter(
                              (item) =>
                                item.id !== itemChangeEmployee?.id &&
                                item.status === userStatus.ACTIVE
                            )
                            ?.map((item) => (
                              <SelectItem
                                key={item.id}
                                value={item.id.toString()}
                              >
                                {item.name}
                              </SelectItem>
                            ))}
                        </SelectContent>
                      </Select>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <div className="flex justify-center">
              <Button type="submit" className="w-[300px] luxury-button-primary">
                Xác nhận
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}

export default CreateUpdate;
